import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import useFormatById from "src/hooks/utils/useFormatById";
import actions from "src/store/auth/actions";

function Identomat() {
    const dispath = useDispatch();
    const formatMessage = useFormatById();

    const progressBarModel = [
        {
            progressNumber: 1,
            progressName: formatMessage("login.persInfo"),
            isActive: true,
        },
        {
            progressNumber: 2,
            progressName: formatMessage("login.remoteAgreement"),
            isActive: false,
        },
        {
            progressNumber: 3,
            progressName: formatMessage("login.remoteAgreementIdentomat"),
            isActive: false,
        },
    ];
    const [currentWizard, setCurrentWizard] = useState(1);
    const [progressBarArr, setProgressBarArr] = useState(progressBarModel);

    // const [pId, setPId] = useState(localStorage.getItem("usr") || "");
    const [pId, setPId] = useState("");
    const isValid = true;

    const showErrors = false;

    const [isLessThen18, setIsLessThen18] = useState(false);
    const [inicials, setInicials] = useState("");

    const [insurerPId, setInsurerPId] = useState("");
    const identomatObj = useSelector(state => state.auth.identomatObj);
    const validateInsurer = useSelector(state => state.auth.validateInsurer);
    const changePage = () => {
        setCurrentWizard((item) => item + 1)
        setProgressBarArr((item) =>
            item.map((x, index) => {
                if (currentWizard === index) {
                    return {
                        ...x,
                        isActive: true,
                    };
                }
                return x;
            })
        );
    }

    useEffect(() => {
        if (identomatObj?.redirectUrl?.length > 0) {
            changePage();
        }

        if (identomatObj?.isUnderage) {
            setIsLessThen18(true);
            setInicials(identomatObj?.insurerInitials);
        }
    }, [identomatObj])

    const handleWizardChange = () => {
        if (currentWizard === 1) {
            if(isLessThen18 && (validateInsurer===undefined || validateInsurer===false)){
            const insurerPayload = {
                personalNumber:pId?.trim(),
                insurerPersonalNumber: insurerPId?.trim()
            }
            dispath(actions.getValidateInsurer(insurerPayload))
            } else {
                const payload = {
                    agreedToTerms: true,
                    personalNumber: pId?.trim(),
                    insurerPersonalNumber:insurerPId?.trim(),
                }
                if (identomatObj?.isUnderage !== true) {delete payload.insurerPersonalNumber}
                dispath(actions.getStartidentomat(payload))
            }
        }
        if (currentWizard === 2) {
            window.location.href = identomatObj?.redirectUrl;
        }
    }

  useEffect(() => {
    if( isLessThen18 && validateInsurer === true && currentWizard === 1){
        const payload = {
            agreedToTerms: true,
            personalNumber: pId?.trim(),
            insurerPersonalNumber:insurerPId?.trim(),
        }
        if (identomatObj?.isUnderage !== true) {delete payload.insurerPersonalNumber}
        dispath(actions.getStartidentomat(payload))
        dispath(actions.setValidateInsurer(undefined))
    }

  }, [validateInsurer, isLessThen18, currentWizard]);

    return (
        <div className="identomat">
            <div
                className={
                    classNames(!isValid && "was-validated") +
                    " d-flex flex-column align-items-center container"
                }
                autoComplete="off"
            >
                <div className="authorization-header p-md-5 p-4">
                    {formatMessage('login.instrucation')}
                </div>
                <div
                    className="recover-password-progress mb-4 text-center"
                    style={{
                        width: "100%",
                    }}
                >
                    <div className="row">
                        {progressBarArr.map((item, index) => (
                            <div
                                className="col-4 progress-container"
                                key={item.progressNumber}
                            >
                                <div
                                    className={
                                        "progress-circle mx-auto mb-2" +
                                        (item.isActive ? " is-active" : " ")
                                    }
                                >
                                    {item.progressNumber}
                                </div>
                                {index < progressBarArr.length - 1 && (
                                    <div className="progress-line"></div>
                                )}
                                <span className={"d-md-block d-none progress-name-indt " + (item?.isActive ? 'is-active-vr' : '')}>{item.progressName}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="p-md-5 p-3 mt-md-0 mt-4">
                    <>
                        {currentWizard === 1 && <>
                            <div className="d-block d-md-none idnet-titles">{formatMessage('login.personalInfo')}</div>
                            <div className="mb-3 d-flex justify-content-center">
                                <div className="form-floating pb-1">
                                    <input
                                        type="text"
                                        className={
                                            "form-control identomat-pin" + (showErrors ? " error-input-style" : "")
                                        }
                                        id="floatingInput"
                                        value={pId}
                                        placeholder="Input"
                                        onChange={(e) => setPId(e.target.value)}
                                        autoComplete="off"
                                        autoFocus
                                    />
                                    <label htmlFor="floatingInput">{formatMessage('pin')}</label>
                                </div>
                                {showErrors && (
                                    <span className="error-text-style">
                                        {formatMessage('cant-find-policy')}
                                    </span>
                                )}
                            </div>

                            {isLessThen18 &&
                                <div className="text-center">
                                    <div className="lessThen18-parag">
                                        {formatMessage('login.lessthen18_1')}{" "}{inicials}
                                        <br /> <br />
                                        {formatMessage('login.lessthen18_2')}{" "}{inicials}{" "}{formatMessage("login.lessthen18_3")}
                                    </div>

                                    <div className="pt-4 d-flex justify-content-center">
                                        <div className="form-floating pb-1">
                                            <input
                                                type="text"
                                                className={
                                                    "form-control identomat-pin" + (showErrors ? " error-input-style" : "")
                                                }
                                                id="floatingInput"
                                                value={insurerPId}
                                                placeholder="Input"
                                                onChange={(e) => setInsurerPId(e.target.value)}
                                                autoComplete="off"
                                                autoFocus
                                            />
                                            <label htmlFor="floatingInput">{formatMessage('login.insurerPid')}</label>
                                        </div>
                                        {showErrors && (
                                            <span className="error-text-style">
                                                {formatMessage('cant-find-policy')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            }
                        </>
                        }
                        {currentWizard === 2 &&
                            <>
                                <div className="d-block d-md-none idnet-titles"> {formatMessage('login.approveTitle')}</div>
                                <div className="approve-title text-center">{formatMessage('login.approve.parag_1')}</div>
                                <div className="approve-parag mobile-st mt-4">
                                    {formatMessage('login.approve_parag_2')}

                                    <br /><br />
                                    {formatMessage('login.approve_parag_3')}


                                    <br /><br />
                                    {formatMessage('login.approve_parag_4')}

                                    <a href="https://identomat.com/terms-and-conditions/" target="_blank" rel="noreferrer"> https://identomat.com/terms-and-conditions/</a>

                                    {formatMessage('login.approve.parag_5')}
                                </div>
                                <div className="approve-parag m-4">
                                    {formatMessage("login.approve.parag3454")}
                                </div>
                            </>
                        }
                    </>
                </div>
                <div className="text-center mb-5">
                    <button className="next-identomat-button"
                        disabled={(currentWizard === 1 && ((identomatObj?.isUnderage && (insurerPId === '' || pId === '')) || (!identomatObj?.isUnderage && pId === ''))) }
                        onClick={() => handleWizardChange()}>
                        {identomatObj === false ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> :
                            formatMessage('next')
                        }
                    </button>
                </div>
            </div>
        </div >
    )

}

export default Identomat;                                                            